type ErrorLike = {
  name?: unknown;
  message?: unknown;
};

const toStr = (v: unknown): string | null => (typeof v === 'string' ? v : null);

const includesAny = (haystack: string, needles: readonly string[]): boolean =>
  needles.some((n) => haystack.includes(n));

const toNormalizedMessage = (v: unknown): string | null => {
  const s = toStr(v);
  return s ? s.toLowerCase() : null;
};

// Keep this list narrow. Avoid generic substrings like "aborted" / "cancelled" which can occur in real failures.
const EXPECTED_ROUTE_CANCEL_MESSAGE_PARTS = [
  'loading initial props cancelled',
  'abort fetching component for route',
  'cancel rendering route',
] as const;

export const isExpectedNextRouteCancellationMessage = (
  message: unknown
): boolean => {
  const msg = toNormalizedMessage(message);
  if (!msg) return false;

  return includesAny(msg, EXPECTED_ROUTE_CANCEL_MESSAGE_PARTS);
};

/**
 * Client-side filter for expected Next.js navigation/route-cancellation noise.
 *
 * Intentionally narrow to avoid dropping aborts that could indicate broken flows.
 */
export const isExpectedAbortOrRouteCancelError = (err: unknown): boolean => {
  if (!err || (typeof err !== 'object' && typeof err !== 'function')) {
    return false;
  }

  const errorLike = err as ErrorLike;
  const message = toStr(errorLike.message);

  // Intentionally filter only known, unactionable Next.js route-cancellation signatures.
  // Do not drop generic AbortError values without a known route-cancel signal.
  return isExpectedNextRouteCancellationMessage(message);
};
